export default "__VITE_ASSET__DTHZSRAW__"